<template>
    <MainContent title="Editar evento">
        <template v-slot:header>
            <h3 class="card-title">Editar evento</h3>
        </template>
        <template v-slot:content>
            <div class="card-body" v-if="!loading">
                <div class="row">
                    <div class="col-12">
                        <FormComponent 
                            :evento="evento" 
                            v-on:terminado="editarEvento"
                        />
                    </div>
                </div>
            </div>
            <div class="card-body" v-else>
                <div class="row">
                    <div class="col-12" style="height: 200px">
                        <LoaderComponent/>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center" v-if="evento && evento.cerrar_butacas_abonados == 1">
                <CerrandoButacasAbonados @confirmar="confirmarCierreButacas()"/>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import FormComponent from '@/components/backend/eventos/FormEvento';
    import MainContent from "@/components/backend/components/MainContent";
    import CerrandoButacasAbonados from "./modals/CerrandoButacasAbonados";

    export default { 
        props: ['evento_id'],
        data() {
            return {
                evento: null,
                loading: false,
                old_cerrar_butacas_abonados: null
            }
        },
        created() {
            this.getEvento();
        },
        methods: {
            getEvento() {
                this.loading = true;

                const data = {
                    evento_id: this.evento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.detalle'), data).then(res => {
                    this.evento = res.data.data;
                    this.old_cerrar_butacas_abonados = this.evento.cerrar_butacas_abonados;
                }).finally(() => this.loading = false);
            },
            editarEvento(data) {
                this.loading = true;

                this.evento = data;

                data.filters = {};         
                    
                if(data.equipo_local_id) {
                    data.equipo_local_id = data.equipo_local_id.id;
                }

                if(data.equipo_visitante_id) {
                    data.equipo_visitante_id = data.equipo_visitante_id.id;
                }

                if(data.division_id) {
                    data.division_id = data.division_id.id;
                }

                if(!data.cerrar_butacas_abonados){
                    data.cerrar_butacas_abonados_no_confirmados = false; 
                }

                data.evento_id = data.id;

                if(data.place_obj) {
                    data.place_id = data.place_obj.id;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.editar'), data).then(() => {
                    this.$toast.success('Evento editado correctamente');
                    if (!data.place_id && data.entradas_compartidas) {
                        this.compartirEventos(data.eventos_compartidos);
                    }
                    if (data.cerrar_butacas_abonados && !this.old_cerrar_butacas_abonados) {
                        this.$modal.show('cerrando-butacas');
                    } else {
                        this.$router.push({ name: 'back.events.index' });
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            compartirEventos(eventos) {
                this.loading = true;

                const params = {
                    event_id: parseInt(this.evento_id),
                    ids_eventos_entradas_compartidas: eventos.map(evento => evento.id)
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.compartir-entradas'), params).then(res => {
                    this.$toast.success('Se están cargando los eventos compartidos');
                }).finally(() => this.loading = false);
            },
            confirmarCierreButacas() {
                this.$modal.hide('cerrando-butacas');
                this.$router.push({ name: 'back.events.index' });
            }
        },
        components: {
            FormComponent, MainContent, CerrandoButacasAbonados
        }
    }
</script>